module.exports = __webpack_public_path__ + "img/category_cover_History.5fc036f.webp";